var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg31SunFace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 78,
    viewBox: "0 0 84 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9007 31.5531C28.3884 29.9449 27.8013 23.6629 30.6262 17.5099C33.4465 11.3672 38.5718 7.68137 42.0892 9.29183C45.6015 10.9 46.1886 17.1821 43.3626 23.3376C40.5434 29.4778 35.4181 33.1636 31.9007 31.5531Z",
    fill: "#F6EEE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3243 41.5391C50.7673 39.9415 50.1292 33.6365 52.888 27.4938C55.6491 21.346 60.8 17.6717 64.3723 19.2761C67.9293 20.8736 68.5675 27.1786 65.8087 33.3213C63.0475 39.4692 57.8966 43.1435 54.3243 41.5391Z",
    fill: "#F6EEE8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0614 63.8495C18.8752 58.4377 11.1204 47.1248 9.7914 34.1533C9.47361 31.0321 9.50928 29.175 9.92394 28.5936C14.6996 21.9258 17.2738 22.6213 17.6437 30.6176C18.2176 43.2192 23.7927 51.8644 34.318 56.5301C44.8573 61.2329 54.9806 59.5462 64.7276 51.5185C70.9362 46.4462 73.1405 47.8968 71.4171 55.9047C71.258 56.6009 69.8821 57.8867 67.3635 59.7341C56.864 67.4545 43.2732 69.2727 31.0614 63.8495Z",
    fill: "#F6EEE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg31SunFace);
export default __webpack_public_path__ + "static/media/3-1-sun-face.59cfa46e74f6c0a6c3f86a2061aae72a.svg";
export { ForwardRef as ReactComponent };